import { useQuery } from '@tanstack/react-query';
import { ArchivedDashboardT, DashboardT } from 'business/definitions';
import { RQAPICallWithData } from 'store/APIClient';

export const ACTIVE_DASHBOARDS_QUERY_KEY = 'dashboards';
export const ARCHIVED_DASHBOARDS_QUERY_KEY = 'archived_dashboards';

/**
 * Fetches active dashboards.
 */
export const useFetchActiveDashboards = () =>
    useQuery({
        queryKey: [ACTIVE_DASHBOARDS_QUERY_KEY],

        queryFn: async () => {
            const response = await RQAPICallWithData<DashboardT[]>({
                endpoint: 'explore/dashboards',
                method: 'GET',
            });
            return response.content.data;
        },
    });

/**
 * Fetches archived dashboards.
 */
export const useFetchArchivedDashboards = () =>
    useQuery({
        queryKey: [ARCHIVED_DASHBOARDS_QUERY_KEY],

        queryFn: async () => {
            const response = await RQAPICallWithData<ArchivedDashboardT[]>({
                endpoint: 'explore/archived_dashboards',
                method: 'GET',
            });
            return response.content.data;
        },
    });
